var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88",
    "data-name": "Group 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.404,
    height: 53.564,
    viewBox: "0 0 53.404 53.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.107,
    x2: 0.893,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 53.404,
    height: 53.564,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M5.26,0V13.88a8.032,8.032,0,0,0,0,15.077V53.564h5.356V28.971a8.029,8.029,0,0,0,0-15.091V0ZM7.938,24.1a2.678,2.678,0,1,1,2.678-2.678A2.679,2.679,0,0,1,7.938,24.1M24.008,0V32.628a8.032,8.032,0,0,0,0,15.077v5.86h5.356V47.719a8.032,8.032,0,0,0,0-15.077V0Zm2.678,42.852a2.678,2.678,0,1,1,2.678-2.678,2.679,2.679,0,0,1-2.678,2.678M45.433,0a8.031,8.031,0,0,0-2.678,15.58V53.564h5.356V15.58A8.031,8.031,0,0,0,45.433,0m0,10.713a2.678,2.678,0,1,1,2.678-2.678,2.679,2.679,0,0,1-2.678,2.678",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon1);
export default __webpack_public_path__ + "static/media/social_icon1.86270d4b0961e97f2d68dc460e986ca6.svg";
export { ForwardRef as ReactComponent };